import styled, { css } from 'styled-components';
import HexagonOutline from '@img/icons/hexagon_outline.svg?url';
import HexagonFilled from '@img/shapes/hexagon-solid.svg?url';
import brand from '@helpers/brand';
import { m } from 'framer-motion';
import { horizontalFadeIn, staggerChildren, verticalFadeIn } from '@helpers/variants';
import { fluidAdjusted } from '@helpers/fluid';
import { Device } from '@helpers/media';
import { transition } from '@helpers/animate';
const Container = styled(m.div).attrs(() => ({
    initial: 'hidden',
    animate: 'visible',
})) `
  --arrowWidth: ${fluidAdjusted(30, 55, Device.Mobile, Device.ActualDesktop)};
  display: grid;
  grid-template-columns: var(--arrowWidth) 1fr var(--arrowWidth);
  width: max-content;
  max-width: 100%;
  gap: ${fluidAdjusted(15, 20, Device.Mobile, Device.ActualDesktop)};
  z-index: 1;
`;
const ArrowContainer = styled(m.button).attrs(({ direction }) => ({
    variants: direction === 'left' ? horizontalFadeIn(-15, 0.75) : horizontalFadeIn(15, 0.75),
})) `
  ${transition('color')};
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.25s ease-in-out;
  background: transparent;
  border: none;
  padding: 0px;


  &[data-disabled='true'] {
    opacity: 0.45 !important;
    pointer-events: none;
  }

  &:hover {
    color: ${brand.secondary.red4};
  }

  svg {
    width: 30px;
  }

  ${({ direction }) => direction === 'right' &&
    css `
      svg {
        transform: rotate(180deg);
      }
    `}
`;
const HexagonContainer = styled(m.div).attrs(() => ({
    variants: staggerChildren(0.15),
})) `
  display: flex;
  height: 84px;
  padding: 0;
`;
const Hexagon = styled(m.button).attrs(() => ({
    variants: verticalFadeIn(20),
})) `
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 31 / 28;
  width: 60px;
  background-image: url('${HexagonOutline}');
  background-repeat: no-repeat;
  transition: all 0.15s ease-in-out;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    color: ${brand.secondary.red4};
  }

  ${({ active }) => active &&
    css `
      background-image: url('${HexagonFilled}');
      color: ${brand.white};
    `};

  span {
    font-family: var(--fontFamily);
    font-size: ${fluidAdjusted(20, 24)};
    font-weight: 600;
    position: relative;
    top: -2px;
    user-select: none;
  }

  ${({ center }) => center
    ? css `
          margin: auto;
        `
    : css `
          &:nth-child(even) {
            margin-top: auto;
          }
          &:nth-child(odd) {
            margin-bottom: auto;
          }
        `}

  margin-left: -10px;

  &:first-child {
    margin-left: unset;
  }
`;
export const PaginationStyles = {
    Container,
    ArrowContainer,
    HexagonContainer,
    Hexagon,
};
